import {
  BRAND_ADD_REQUEST,
  BRAND_ADD_SUCCESS,
  BRAND_ADD_FAILURE,
  BRAND_EDIT_REQUEST,
  BRAND_EDIT_SUCCESS,
  BRAND_EDIT_FAILURE,
  BRAND_VIEW_REQUEST,
  BRAND_VIEW_SUCCESS,
  BRAND_VIEW_FAILURE,
  BRAND_VIEW_ALL_REQUEST,
  BRAND_VIEW_ALL_SUCCESS,
  BRAND_VIEW_ALL_FAILURE,
  BRAND_DELETE_REQUEST,
  BRAND_DELETE_SUCCESS,
  BRAND_DELETE_FAILURE,
  BRAND_RESET_STATE,
  BRAND_SEARCH_REQUEST,
  BRAND_SEARCH_SUCCESS,
  BRAND_SEARCH_FAILURE,
  BRAND_VIEW_BY_ALCOHOL_ID_REQUEST,
  BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS,
  BRAND_VIEW_BY_ALCOHOL_ID_FAILURE,
} from "./BrandTypes";

// Add Brand Actions
export const brandAddRequest = (credentials) => ({
  type: BRAND_ADD_REQUEST,
  payload: credentials,
});

export const brandAddSuccess = (brand) => ({
  type: BRAND_ADD_SUCCESS,
  payload: brand,
});

export const brandAddFailure = (error) => ({
  type: BRAND_ADD_FAILURE,
  payload: error,
});

// Edit Brand Actions
export const brandEditRequest = (brandId, updatedData) => ({
  type: BRAND_EDIT_REQUEST,
  payload: { brandId, updatedData },
});

export const brandEditSuccess = (brand) => ({
  type: BRAND_EDIT_SUCCESS,
  payload: brand,
});

export const brandEditFailure = (error) => ({
  type: BRAND_EDIT_FAILURE,
  payload: error,
});

// View Brand Actions
export const brandViewRequest = (brandId) => ({
  type: BRAND_VIEW_REQUEST,
  payload: brandId,
});

export const brandViewSuccess = (brand) => ({
  type: BRAND_VIEW_SUCCESS,
  payload: brand,
});

export const brandViewFailure = (error) => ({
  type: BRAND_VIEW_FAILURE,
  payload: error,
});

// View All Brand Actions
export const brandViewAllRequest = (payload) => ({
  type: BRAND_VIEW_ALL_REQUEST,
  payload,
});

export const brandViewAllSuccess = (brands) => ({
  type: BRAND_VIEW_ALL_SUCCESS,
  payload: brands,
});

export const brandViewAllFailure = (error) => ({
  type: BRAND_VIEW_ALL_FAILURE,
  payload: error,
});

// View Brand By Alcohol Id Actions
export const brandViewByAlcoholIdRequest = (alcoholId) => ({
  type: BRAND_VIEW_BY_ALCOHOL_ID_REQUEST,
  payload: alcoholId,
});

export const brandViewByAlcoholIdSuccess = (brands) => ({
  type: BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS,
  payload: brands,
});

export const brandViewByAlcoholIdFailure = (error) => ({
  type: BRAND_VIEW_BY_ALCOHOL_ID_FAILURE,
  payload: error,
});

// View All Search Brand Actions
export const brandSearchViewAllRequest = () => ({
  type: BRAND_SEARCH_REQUEST,
});

export const brandSearchViewAllSuccess = (brands) => ({
  type: BRAND_SEARCH_SUCCESS,
  payload: brands,
});

export const brandSearchViewAllFailure = (error) => ({
  type: BRAND_SEARCH_FAILURE,
  payload: error,
});

// Delete Brand Actions
export const brandDeleteRequest = (brandId) => ({
  type: BRAND_DELETE_REQUEST,
  payload: brandId,
});

export const brandDeleteSuccess = (brandId) => ({
  type: BRAND_DELETE_SUCCESS,
  payload: brandId,
});

export const brandDeleteFailure = (error) => ({
  type: BRAND_DELETE_FAILURE,
  payload: error,
});

//Reset Product
export const brandResetState = () => ({
  type: BRAND_RESET_STATE,
});
